<template>
  <div>
    <Toast
      v-for="toast in toasts"
      :key="toast.id"
      :message="toast.message"
      :type="toast.type"
      :duration="toast.duration"
      :dismissible="toast.dismissible"
      @dismiss="removeToast(toast.id)"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Toast from './Toast.vue'

const toasts = ref([])
let nextId = 0

function showToast(message, type = 'info', duration = 5000, dismissible = true) {
  const id = nextId++
  toasts.value.push({
    id,
    message,
    type,
    duration,
    dismissible,
  })
  return id
}

function removeToast(id) {
  const index = toasts.value.findIndex(t => t.id === id)
  if (index !== -1) {
    toasts.value.splice(index, 1)
  }
}

function success(message, duration = 5000) {
  return showToast(message, 'success', duration)
}

function error(message, duration = 7000) {
  return showToast(message, 'error', duration)
}

function warning(message, duration = 6000) {
  return showToast(message, 'warning', duration)
}

function info(message, duration = 5000) {
  return showToast(message, 'info', duration)
}

defineExpose({
  showToast,
  success,
  error,
  warning,
  info,
  removeToast,
})
</script>
